import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// Non-invasive test hook: lets the mobile regression suite trigger a toast on
// any route (to assert it clears fixed top chrome) without mutating data.
if (typeof window !== "undefined") {
  window.__jtrToast = toast;
}

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      position="top-right"
      richColors
      closeButton
      duration={5000}
      visibleToasts={4}
      gap={12}
      offset={{ top: "84px", right: "16px", left: "16px", bottom: "16px" }}
      mobileOffset={{ top: "calc(env(safe-area-inset-top, 0px) + 96px)", left: "12px", right: "12px", bottom: "12px" }}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:shadow-xl group-[.toaster]:border group-[.toaster]:rounded-xl group-[.toaster]:font-medium group-[.toaster]:text-sm",
          description: "group-[.toast]:text-xs group-[.toast]:opacity-90 group-[.toast]:mt-0.5",
          title: "group-[.toast]:font-bold",
          closeButton:
            "group-[.toast]:!h-11 group-[.toast]:!w-11 group-[.toast]:!left-auto group-[.toast]:!right-1 group-[.toast]:!top-1 group-[.toast]:!rounded-lg group-[.toast]:[&>svg]:!h-4 group-[.toast]:[&>svg]:!w-4",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:!border-emerald-300 group-[.toaster]:!bg-gradient-to-br group-[.toaster]:!from-emerald-50 group-[.toaster]:!to-white group-[.toaster]:!text-emerald-900",
          error:
            "group-[.toaster]:!border-rose-300 group-[.toaster]:!bg-gradient-to-br group-[.toaster]:!from-rose-50 group-[.toaster]:!to-white group-[.toaster]:!text-rose-900",
          info:
            "group-[.toaster]:!border-indigo-300 group-[.toaster]:!bg-gradient-to-br group-[.toaster]:!from-indigo-50 group-[.toaster]:!to-white group-[.toaster]:!text-indigo-900",
          warning:
            "group-[.toaster]:!border-amber-300 group-[.toaster]:!bg-gradient-to-br group-[.toaster]:!from-amber-50 group-[.toaster]:!to-white group-[.toaster]:!text-amber-900",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
